export { default } from './CanaisAtendimentoCustomTabs';
